import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { CircularProgress, IconButton } from "@mui/material";
import { useSnackbar } from "notistack";
import { makeStyles } from "@mui/styles";
import { s3baseUrl } from "src/config/config";
import ChatCard from "src/components/SupportTickets/ChatCard";
import ModelBox from "src/components/ModalBox/ImageModalBox";
import {
  csvImage,
  docImage,
  pdfImage,
  wordImage,
  audioImage,
  xlsxImage,
  otherImage,
} from "src/assets";
const imageLinks = {
  docx: wordImage,
  mp3: audioImage,
  pdf: pdfImage,
  csv: csvImage,
  doc: docImage,
  xlsx: xlsxImage,
  xls: xlsxImage,
  other: otherImage,
};
import {
  _internal_note,
  markResolved,
  SupportTicketDetailApi,
} from "src/DAL/SupportTicket/SupportTicket";
import { htmlDecode } from "src/utils/convertHtml";
import CustomConfirmation from "src/components/menuIcons/CustomConfirmation";
import CustomPopover from "src/components/CustomPopover";
import moment from "moment";
import { useContentSetting } from "src/Hooks/ContentSettingState";
import { TIME_ZONE_CONVERSION } from "src/utils/constants";
import CustomDrawer from "src/components/DrawerForm/CustomDrawer";
import MarkResolve from "./MarkResolve";
import InternalNote from "../SupportTicket/InternalNote";
import InternalNoteNew from "../SupportTicket/InternalNoteNew";
import FullPagePopupSupportTicket from "./FullPagePopupSupportTicket";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

export default function InternalTicketDetail(props) {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();
  const params = useParams();
  const { state } = useLocation();
  const [supportTicketData, setSupportTicketData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [internalNoteCount, setinternalNoteCount] = useState("");
  const [drawerInternalNote, setdrawerInternalNote] = useState(false);
  const [drawerMarkResolveState, setdrawerMarkResolveState] = useState(false);
  const [ticketData, setticketData] = useState();
  const [openResolved, setOpenResolved] = useState(false);
  const [AutoResponded, setAutoResponded] = useState([]);
  const [ticketId, setTicketId] = useState("");
  const [lastAction, setlastAction] = useState("");
  const [MemberData, setMemberData] = useState({});
  const [imageUrl, setImageUrl] = useState("");
  const { adminTimeZone, userInfo } = useContentSetting();
  const handleOpen = (image_path) => {
    setImageUrl(image_path);
    setOpen(true);
  };

  const handleCloseMarkResolveDrawer = () => {
    setdrawerMarkResolveState(false);
  };

  const handleClose = () => setOpen(false);

  const getSupportTicketDetail = async () => {
    setIsLoading(true);
    const result = await SupportTicketDetailApi(params.id);
    if (result.code === 200) {
      setMemberData(result.support_ticket);
      setSupportTicketData(result.support_ticket);
      setlastAction(result.support_ticket.last_action_date);
      setAutoResponded(
        result.auto_responder_message,
        "result.auto_responder_message"
      );
      setIsLoading(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      navigate(`/internal-tickets`);
    }
  };

  const get_last_responded_time = (date) => {
    return TIME_ZONE_CONVERSION(
      date,
      "DD-MM-YYYY hh:mm A",
      adminTimeZone,
      userInfo.time_zone
    );
  };
  const handleNavigate = () => {
    // navigate("/internal-tickets", { state: state ? state : 0 });
    navigate(-1);
  };
  const handleOpenMarkResolveDrawer = (value) => {
    setdrawerMarkResolveState(true);
    setTicketId(params.id ? params.id : value.id);
  };

  const handleCopyString = async (value, name) => {
    await navigator.clipboard.writeText(value);
    enqueueSnackbar(name + " Copied", { variant: "success" });
  };

  const handleMarkResolved = async () => {
    setOpenResolved(false);
    setIsLoading(true);
    const result = await markResolved(params.id);
    if (result.code === 200) {
      getSupportTicketDetail(result.support_ticket);
      enqueueSnackbar(result.message, { variant: "success" });
      setIsLoading(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };
  const getInternalNote = async () => {
    setIsLoading(true);
    const result = await _internal_note(params.id);
    if (result.code === 200) {
      setinternalNoteCount(result?.support_ticket?.internal_note.length);

      setIsLoading(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };
  const handleOpenInternalNoteDrawer = (value, id) => {
    setdrawerInternalNote(true);
    setTicketId(id ? id : params.id ? params.id : value.id);
  };
  const handleCLoseInternalNoteCLoseDrawer = () => {
    setdrawerInternalNote(false);
    getInternalNote();
  };
  const getCommentImage = (file) => {
    const ext = file.thumbnail_1.split(".").pop();
    if (
      ext == "jpg" ||
      ext == "JPG" ||
      ext == "png" ||
      ext == "webp" ||
      ext == "jpeg" ||
      ext == "JPEG" ||
      ext == "PNG"
    ) {
      return s3baseUrl + file.thumbnail_2;
    } else if (imageLinks[ext]) {
      return imageLinks[ext];
    } else {
      return imageLinks.other;
    }
  };

  const MENU_OPTIONS = [
    {
      label:
        supportTicketData.ticket_status === 1 ||
        supportTicketData.ticket_status === 2
          ? "Resolved"
          : "Mark Resolve",
      icon: "gg:details-more",
      handleClick:
        supportTicketData.ticket_status === 1 ||
        supportTicketData.ticket_status === 2
          ? () => {}
          : handleOpenMarkResolveDrawer,
    },
  ];
  useEffect(() => {
    getSupportTicketDetail();
  }, []);
  useEffect(() => {
    if (state) {
      if (state.open == true) {
        handleOpenInternalNoteDrawer("", state.support_ticket);
      }
    }
  }, []);

  useEffect(() => {
    getInternalNote();
  }, []);

  if (isLoading) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }
  return (
    <>
      {Object.keys(MemberData).length > 0 ? (
        <div className="container">
          <div className="row mobile-margin display-flex">
            <div className="col-12 button-menu">
              <div>
                <IconButton
                  className="back-screen-button me-3"
                  onClick={handleNavigate}
                >
                  <ArrowBackIcon />
                </IconButton>
                <span
                  className="anchor-style"
                  onClick={() =>
                    handleCopyString(state?.value?.member?.email, "Email")
                  }
                >
                  {MemberData?.member?.first_name +
                    " " +
                    MemberData?.member?.last_name +
                    " (" +
                    MemberData?.member?.email +
                    ")"}
                </span>
              </div>

              <div style={{ display: "flex" }}>
                <button
                  className="small-contained-button float-end mt-1 ms-2"
                  onClick={() => handleOpenInternalNoteDrawer()}
                >
                  Internal Notes ({internalNoteCount ? internalNoteCount : "0"})
                </button>
                <CustomPopover menu={MENU_OPTIONS} />
              </div>
            </div>
          </div>
          <div className="row section-space-support-ticket-setail">
            <div className="col-sm-12 col-lg-6 col-md-6 d-flex justify-content-between mt-4">
              {supportTicketData.subject && (
                <h1 style={{ width: "100%" }}>
                  {htmlDecode(supportTicketData.subject)}
                </h1>
              )}
            </div>
            <div className="col-sm-12 col-lg-6 col-md-6 d-flex justify-content-end mt-4">
              <div className="detials-date-container">
                <div className="d-flex">
                  <h4 style={{ color: "#f6bd4b" }}>Created Date:</h4>
                  {state?.value?.createdAt && (
                    <span className="ms-2">
                      {moment(state?.value?.createdAt).format(
                        "DD-MM-YYYY hh:mm A"
                      )}
                    </span>
                  )}
                </div>
                <div className="d-flex">
                  <h4 style={{ color: "#f6bd4b" }} className="mt-1">
                    Responded Time:
                  </h4>
                  <span className="ms-2" style={{ marginTop: "3px" }}>
                    {lastAction
                      ? get_last_responded_time(lastAction)
                      : "Not Responded Yet"}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="row media-margin">
            <div className="col-12">
              {supportTicketData.description && (
                <p>{htmlDecode(supportTicketData.description)}</p>
              )}
            </div>
            <div className="col-sm-12 my-2">
              {supportTicketData.ticket_images &&
                supportTicketData.ticket_images.map((image, i) => {
                  const ext = image.thumbnail_1.split(".").pop();
                  if (
                    ext == "jpg" ||
                    ext == "JPG" ||
                    ext == "png" ||
                    ext == "webp" ||
                    ext == "jpeg" ||
                    ext == "JPEG" ||
                    ext == "PNG"
                  ) {
                    return (
                      <span className="preview ticket_image_preview" key={i}>
                        <img
                          onClick={() => {
                            handleOpen(s3baseUrl + image.thumbnail_1);
                          }}
                          className="p-0"
                          src={s3baseUrl + image.thumbnail_2}
                        />
                      </span>
                    );
                  } else {
                    return (
                      <span className="preview ticket_image_preview" key={i}>
                        <a
                          href={s3baseUrl + image.thumbnail_1}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img src={getCommentImage(image)} />
                        </a>
                      </span>
                    );
                  }
                })}
            </div>
            <ChatCard
              comments={supportTicketData.comment}
              ticket_id={supportTicketData._id}
              AutoResponded={AutoResponded}
              list_data={getSupportTicketDetail}
              supportTicketData={supportTicketData}
              setlastAction={setlastAction}
              memberName={state?.value?.object?.member?.first_name}
              memberEmail={state?.value?.object?.member?.email}
            />
            <ModelBox
              open={open}
              handleClose={handleClose}
              image_url={imageUrl}
            />
            <CustomConfirmation
              open={openResolved}
              setOpen={setOpenResolved}
              title={"Are you sure you want to mark this Ticket as resolved?"}
              handleAgree={handleMarkResolved}
            />
            <CustomDrawer
              isOpenDrawer={drawerMarkResolveState}
              onOpenDrawer={handleOpenMarkResolveDrawer}
              onCloseDrawer={handleCloseMarkResolveDrawer}
              pageTitle="Mark Resolve"
              componentToPassDown={
                <MarkResolve
                  formType="ADD"
                  ticketId={ticketId}
                  dataList={getSupportTicketDetail}
                  onCloseDrawer={handleCloseMarkResolveDrawer}
                />
              }
            />
            <FullPagePopupSupportTicket
              open={drawerInternalNote}
              setOpen={setdrawerInternalNote}
              ticketData={MemberData}
              componentToPassDown={
                <InternalNoteNew
                  formType="ADD"
                  ticketId={params.id}
                  setinternalNoteCount={setinternalNoteCount}
                  onCloseDrawer={handleCLoseInternalNoteCLoseDrawer}
                />
              }
            />
          </div>
        </div>
      ) : (
        <CircularProgress className={classes.loading} color="primary" />
      )}
    </>
  );
}
